import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'delete' | 'confirm' | 'warning';
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  // Default texts
  confirmText: string = 'Yes';
  cancelText: string = 'No';
  confirmButtonClass: string = 'primary-btn';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    // Set default or provided texts
    if (data.confirmText) {
      this.confirmText = data.confirmText;
    }
    if (data.cancelText) {
      this.cancelText = data.cancelText;
    }
    if (data.type === 'delete') {
      this.confirmButtonClass = 'delete-btn';
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
